/* unplugin-vue-components disabled */import script from "./player.vue?vue&type=script&setup=true&lang=ts"
export * from "./player.vue?vue&type=script&setup=true&lang=ts"

import "./player.vue?vue&type=style&index=0&id=60d3c1a8&lang=less&scoped=true"

import exportComponent from "/Users/liao/work/cmge/ultrasdk/ultrasdk.hub.web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.4.21_vue@3.4.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60d3c1a8"]])

export default __exports__